// Non-color design primitives (option tokens) and semantic aliases
// (decision tokens). Keep this file free of imports so it stays portable.
//
// Consumption rule (mirrors grey200 -> outline for colors): styled-components
// consume role-named aliases only, never primitives. Primitives may be imported
// solely to define aliases here or component-local layout constants in the
// component's common file. Raw px is fine for true one-off geometry.

// Primitives — value-named, category first (matches grey200/blue400 naming)
export const radius4 = '4px'
export const radius6 = '6px'
export const radius8 = '8px'
export const radius10 = '10px'

export const space4 = '4px'
export const space8 = '8px'
export const space12 = '12px'
export const space16 = '16px'
export const space20 = '20px'
export const space24 = '24px'
export const space32 = '32px'

export const fontSize11 = '11px'
export const fontSize12 = '12px'
export const fontSize13 = '13px'
export const fontSize14 = '14px'
export const fontSize16 = '16px'
export const fontSize18 = '18px'

export const fontWeightRegular = 400
export const fontWeightMedium = 500
export const fontWeightSemibold = 600
export const fontWeightBold = 700

export const letterSpacingWide = '0.06em'

export const shadowSm = '0 1px 2px rgba(0, 0, 0, 0.07)'
export const shadowMd = '0 4px 12px rgba(0, 0, 0, 0.10)'
export const focusRing = '0 0 0 3px rgba(40, 133, 241, 0.18)' // primary (blue400) at 18%

export const durationFast = '0.1s'
export const durationNormal = '0.15s'
export const easingStandard = 'ease-in-out'

// Semantic aliases — role-named
export const radiusInput = radius6 // inputs, buttons, segmented control
export const radiusCard = radius10 // cards / page-level containers
export const radiusRow = radius6 // hover highlight on property rows
export const spaceCardPadding = space20 // card / panel inner padding
export const spaceCardGap = space32 // vertical gap between cards on a page
export const fontSizeLabel = fontSize12
export const fontSizeValue = fontSize13
export const fontSizeTitle = fontSize14
export const fontSizePageTitle = fontSize18 // page heading above a card
export const fontSizeSectionHeader = fontSize11
export const fontSizeInput = fontSize14 // shared text inputs
export const fontSizeMeta = fontSize12 // captions, error text, secondary text
